import React from 'react'
import Fab from '@material-ui/core/Fab'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
	root: {
		color: '#fff',
		boxShadow: theme.shadows[3],
		'&:active': {
			boxShadow: theme.shadows[3],
		},
		background: props =>
			props.color === 'primary'
				? 'linear-gradient(135deg, #FAB2FF 10%, #1904E5 100%)'
				: 'linear-gradient(135deg, #2AFADF 10%, #4C83FF 100%)',
	},
}))

function GradientFab(props) {
	const { color, ...other } = props
	const classes = useStyles(props)
	return <Fab classes={classes} {...other} />
}

export default GradientFab
